/**
 * Route paths in the application
 */

export const routePaths = {
  root: "/",
  login: "/login",
  signup: "/signup",
  dashboard: "/dashboard",
  register: "/register",
  shared: "/shared/:token",
  sharedBase: "/shared",
  meterLookup: "/meter-lookup",
};
